module.exports = __webpack_public_path__ + "static/media/logo_FC_green_small.46e61fbd.png";